// extracted by mini-css-extract-plugin
export default {"ProjectLogo":"ProjectLogo_ProjectLogo__nQwEm"};